<template>
  <section class="container">
    <div class="management_top_box mb-3">
      <h4>{{ $t("management.relatedLinksRegister") }}</h4>
    </div>
    <div class="brick_box">
      <table class="write_tbl responsive_tbl">
        <tbody>
          <tr>
            <th>{{ $t("management.siteName") }}</th>
            <td>
              <input
                type="text"
                name="className"
                v-model="link.linkName"
                class="int_type01"
                maxlength="100"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("management.url") }}</th>
            <td>
              <input
                type="text"
                v-model="link.linkUrl"
                class="int_type01"
                maxlength="100"
                v-validate="'required'"
              />
            </td>
          </tr>
          <tr>
            <th>{{ $t("common.description") }}</th>
            <td>
              <input
                type="text"
                v-model="link.description"
                class="int_type01"
                maxlength="350"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/relatedlink"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button @click="saveRelatedLink" class="btn btn-primary btn-lg m-1">
          {{ $t("common.save") }}
        </button>
        <button
          v-if="link.crudType == 'U'"
          @click="deleteRelatedLink"
          class="btn btn-secondary btn-lg m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { getRelatedLink, saveRelatedLink, deleteRelatedLink } from "@/api/relatedlink";
import { validateURL } from "@/utils/validation";
export default {
  data() {
    return {
      link: { linkId: "", crudType: "I" },
      linkId: "",
    };
  },
  mounted() {
    if (this.$route.params.linkId != null) {
      this.fetchData();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.link.linkId = this.$route.params.linkId;
        const { data } = await getRelatedLink(this.link);
        this.link = data.link;
        if (this.link != null) {
          this.link.crudType = "U";
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 수정/저장
    async saveRelatedLink() {
      const validForm = await this.$validator.validateAll();
      if (!validForm) return alert(this.$t("alert.plzCheckAllValues"));
      if (!validateURL(this.link.linkUrl))
        return alert(this.$t("alert.checkTheURLWithFormat"));
      try {
        const { data } = await saveRelatedLink(this.link);
        if (data.status) {
          this.$router.push({ name: "mgmtRelatedLink" });
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 삭제
    async deleteRelatedLink() {
      this.confirmYN = confirm(this.$t("alert.delete"));
      if (this.confirmYN) {
        try {
          const { data } = await deleteRelatedLink(this.link);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.$router.push({ name: "mgmtRelatedLink" });
          } else {
            alert(this.$t("alert.ErrorPleasecontactManager"));
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        return;
      }
    },
  },
};
</script>

<style></style>
